import { ThemeProvider } from "styled-components";
import React, { useState, useEffect, Suspense } from "react";
import { darkTheme, lightTheme } from "./utils/Themes.js";
import Navbar from "./components/Navbar";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HeroSection from "./components/HeroSection";
import About from "./components/About";
import Skills from "./components/Skills";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ProjectDetails from "./components/ProjectDetails";
import RockPaperScissors from "./components/Games/RockPaperScissors";
import MemoryGame from "./components/Games/MemoryGame";
import MiniSudoku from "./components/Games/MiniSudoku";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga4";
import * as Sentry from "@sentry/react";

// Lazy load heavy components
const Projects = React.lazy(() => import("./components/Projects"));
const Experience = React.lazy(() => import("./components/Experience"));
const Education = React.lazy(() => import("./components/Education"));
const Blog = React.lazy(() => import("./components/Blog"));

const Body = styled.div`
  background-color: ${({ theme }) => theme.bg};
  width: 100%;
  overflow-x: hidden;
`;

const Wrapper = styled.div`
  background: linear-gradient(
      38.73deg,
      rgba(18, 27, 51, 1) 0%,
      rgba(201, 32, 184, 0) 50%
    ),
    linear-gradient(
      141.27deg,
      rgba(0, 70, 209, 0) 50%,
      rgba(0, 70, 209, 0.15) 100%
    );
  width: 100%;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 30% 98%, 0 100%);
`;
function App() {
  const [darkMode, setDarkMode] = useState(true);
  const [openModal, setOpenModal] = useState({ state: false, project: null });

  useEffect(() => {
    // Initialize Google Analytics
    ReactGA.initialize(process.env.REACT_APP_GA_ID);
    ReactGA.send("pageview");

    // Initialize Sentry
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      // integrations: [
      //   new BrowserTracing(),
      //   new Sentry.Replay(),
      // ],
      tracesSampleRate: 1.0,
      // replaysSessionSampleRate: 0.1,
      // replaysOnErrorSampleRate: 1.0,
    });
  }, []);

  console.log(openModal);

  const MainContent = () => (
    <>
      <Body>
        <HeroSection />
        <Wrapper>
          <Skills />
          <Suspense fallback={<div>Loading...</div>}>
            <Experience />
          </Suspense>
        </Wrapper>
        <Suspense fallback={<div>Loading...</div>}>
          <Projects openModal={openModal} setOpenModal={setOpenModal} />
        </Suspense>
        <Suspense fallback={<div>Loading...</div>}>
          <Blog />
        </Suspense>
        <Wrapper>
          <Suspense fallback={<div>Loading...</div>}>
            <Education />
          </Suspense>
          <Contact />
        </Wrapper>
        <Footer />
        {openModal.state && (
          <ProjectDetails openModal={openModal} setOpenModal={setOpenModal} />
        )}
      </Body>
    </>
  );

  return (
    <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
      <Helmet>
        <title>Gaspar Dantas - Software Engineer Portfolio</title>
        <meta name="description" content="Portfolio of Gaspar Dantas, a Computer Science student and Software Engineer showcasing projects in web development, data analysis, and more." />
        <meta name="keywords" content="Gaspar Dantas, portfolio, software engineer, web development, React, data analysis" />
        <meta property="og:title" content="Gaspar Dantas - Software Engineer Portfolio" />
        <meta property="og:description" content="Explore my projects and skills in software engineering." />
        <meta property="og:image" content="https://your-domain.com/og-image.jpg" />
        <meta property="og:url" content="https://gaspardantas2025.s3.amazonaws.com" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/rps" element={<RockPaperScissors />} />
          <Route path="/mg" element={<MemoryGame />} />
          <Route path="/sudoku" element={<MiniSudoku />} />
          <Route path="*" element={<MainContent />} />
        </Routes>
      </Router>
      </ThemeProvider>
  );
}

export default App;
